<div class="upload-dialog">
  <div class="upload-dialog-header">
    <h3>Upload Document</h3>
  </div>

  <div class="upload-dialog-content">
    <p class="upload-description">
      Please attach relevant documents related to your payment, such as receipts, invoices,
      contracts, reports, or authorizations.
    </p>

    <div
      class="upload-area"
      [class.drag-active]="dragActive"
      [class.has-file]="uploadedFile"
      [class.has-error]="uploadError"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <ng-container *ngIf="!uploadedFile && !uploadError">
        <div class="upload-content">
          <div class="upload-text">
            <span>Drag & drop your file here or </span>
            <button type="button" class="browse-link" (click)="browseFile()">Browse File</button>
          </div>
          <div class="file-format-info">Format zip or PDF, max size {{ maxUploadSizeMB }}mb</div>
        </div>
      </ng-container>

      <ng-container *ngIf="uploadedFile && !uploadError">
        <div class="uploaded-file">
          <i class="pi pi-file-pdf file-icon"></i>
          <span class="file-name">{{ uploadedFile.name }}</span>
          <button type="button" class="remove-file" (click)="removeFile()">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="uploadError">
        <div class="upload-content">
          <div class="upload-text">
            <span>Drag & drop your file here or </span>
            <button type="button" class="browse-link" (click)="browseFile()">Browse File</button>
          </div>
          <div class="file-format-error">
            {{ errorMessage }}
          </div>
        </div>
      </ng-container>

      <input
        type="file"
        id="fileInput"
        class="file-input"
        accept=".pdf,.zip"
        (change)="onFileSelected($event)"
        hidden
      />
    </div>
  </div>

  <div class="upload-dialog-footer">
    <lib-button label="Cancel" type="Secondary" (click)="cancel()"> </lib-button>
    <lib-button
      type="Primary"
      label="Save"
      [disabled]="!uploadedFile || uploadError"
      (click)="save()"
    >
    </lib-button>
  </div>
</div>
